import React from 'react';
import { useSelector } from "react-redux";

export const useErrorFile = () => {
	const { dict } = useSelector(state => state.app);

	const getErrorFile = (error) => {
		switch (error) {
			case "file-invalid-type":
				return dict.file.errors.format;
			case "too-many-files":
				return dict.file.errors.files;
			default:
				return "";
		}
	};

	return getErrorFile;
};

export const useAcceptedFile = () => {
	const { dict } = useSelector(state => state.app);
    
	const acceptedFile = (acceptedFiles) => {
		return acceptedFiles.map(file => (
			<p className="modal__load-dictionary--file"
				key={ file.name }>
				{dict.file.name} <strong>{file.name}</strong>
			</p>
		));
	};

	return acceptedFile;
};